/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q9Inputs */

const et_faq_q9 = /** @type {(inputs: Faq_Q9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miks on SEO ja veebi optimeerimine kuutasupõhine teenus?`)
};

const en_faq_q9 = /** @type {(inputs: Faq_Q9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are SEO and website optimization monthly services?`)
};

/**
* | output |
* | --- |
* | "Why are SEO and website optimization monthly services?" |
*
* @param {Faq_Q9Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q9 = /** @type {((inputs?: Faq_Q9Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q9Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q9(inputs)
	return en_faq_q9(inputs)
});